import store from 'store.js';

import { getUserL2Access, selectedLoggedInUsersAccesses } from 'Deer/helpers/getUserAccess';

import { FEATURE_KEYS } from 'constants/ProjectConstants';

import { selectEnabledFeatures } from 'selectors/enabledFeatures';

export const checkModuleEnabled = (moduleKey) => {
  if (!FEATURE_KEYS[moduleKey]) {
    console.error(`Module named '${moduleKey}' is not a valid module key. Not found in FEATURE_KEYS`);
    return false;
  }
  const enabledFeatures = selectedLoggedInUsersAccesses(store.getState()).enabledFeatures;
  return enabledFeatures.includes(moduleKey);
};

export const checkAnyTeamPageModuleEnabled = () => {
  const enabledFeatures = selectedLoggedInUsersAccesses(store.getState()).enabledFeatures;
  return enabledFeatures.includes(FEATURE_KEYS.TASK) || enabledFeatures.includes(FEATURE_KEYS.GOAL);
};

export const checkGoalModuleEnabled = () => getUserL2Access().hasGoalAccess;

export const checkTaskModuleEnabled = () => {
  const enabledFeatures = selectEnabledFeatures(store.getState());
  return enabledFeatures.includes(FEATURE_KEYS.TASK);
};

export const checkReviewModuleEnabled = () => getUserL2Access().hasReviewAccess;

export const checkFeedbackModuleEnabled = () => getUserL2Access().hasFeedbackAccess;

export const checkEngagementModuleEnabled = () => getUserL2Access().hasEngagementAccess;

export const checkDisciplinaryModuleEnabled = () => getUserL2Access().hasDisciplinaryActionsAccess;

export const checkOneOnOneModuleEnabled = () => getUserL2Access().hasOneOnOneAccess;

export const checkLevelUpModuleEnabled = () => {
  const enabledFeatures = selectEnabledFeatures(store.getState());
  return enabledFeatures.includes(FEATURE_KEYS.LEVEL_UP);
};

export const checkCompensationModuleEnabled = () => getUserL2Access().hasCompensationAccess;

export const checkPointsModuleEnabled = () => getUserL2Access().hasPointsAccess;

export const checkRewardsModuleEnabled = () => getUserL2Access().hasRewardsAccess;
